/* Application name */
export const APP_NAME = "tillganglighet-anmalan-sp";
export const APP_SLUG = "TillganglighetAnmalan";

/* Textkey for subject and email address */
export const SERVICE_BASE = "anmtillganglighetsbrist.tjanst.";
export const SKICKA_EPOST_MOTTAGARE_BASE = "skickaepost.tillganglighet.";
export const SKICKA_EPOST_MOTTAGARE_DEFAULT_SERVICE_PARAM = "fk";

/* URL to fetch texts */
export const APP_TRANSLATIONS_URL =
    "/fk_apps/GenerelltREST/public/v1/wcmcontent/tillganglighet_anmalan_2020";

/**
 * URL to navigate to when returning from the application, e.g. when aborting or
 * navigating from receipt.
 *
 * Examples:
 *
 * - Oinloggat: /wps/portal
 * - Inloggad:  /wps/myportal/privatpers/minasidor
 */
export const APP_ENTRY_POINT_URL = "/wps/portal";
